import { Button } from "@mui/material";
import { SlidersHorizontal } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { NotificationCenterTabs } from "web_myplann/NotificationCenter/Components/NotificationCenterTabs";
import type { NotificationCenterTab } from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useIsTimelineFilterDefault } from "web_myplann/NotificationCenter/Hooks/useIsTimelineFilterDefault";
import { useNotificationCenterTabs } from "web_myplann/NotificationCenter/Hooks/useNotificationCenterTabs";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type Props = {
	activeTab: NotificationCenterTab;
	onTabChange: (tab: NotificationCenterTab) => void;
};

export const NotificationCenterLegacyTopBar: FC<Props> = ({
	activeTab,
	onTabChange,
}) => {
	const { t } = useResource();
	const navigate = useNavigate();
	const isFilterDefault = useIsTimelineFilterDefault();
	const { tabs, value, onChange } = useNotificationCenterTabs(
		activeTab,
		onTabChange,
	);

	const handleFilterClick = () => {
		navigate(Routing.NotificationsFilter.path(activeTab));
	};

	return (
		<NavigationHeader
			title={t(Resources.NotificationCenter.Title)}
			defaultRoute={Routing.Dashboard.path()}
			endComponent={
				<Button
					variant="deprecatedHeaderAction"
					color={isFilterDefault ? "neutral" : "primary"}
					onClick={handleFilterClick}
					aria-label={t(Resources.NotificationCenter.Filter.Button)}
					data-testid="notification-center-filter-button"
					startIcon={<SlidersHorizontal size={18} />}
				/>
			}
			bottomComponent={
				<NotificationCenterTabs value={value} onChange={onChange} tabs={tabs} />
			}
			disableBottomPadding
		/>
	);
};
